module.exports = __webpack_public_path__ + "static/media/kia-street-selected.1162287c.svg";